import { useState, useCallback } from 'react';

export const useExpandableRows = (initialIds: string[] = []) => {
    const [expanded, setExpanded] = useState<string[]>(initialIds);

    const toggle = useCallback((id: string) => {
        setExpanded((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
    }, []);

    const expandAll = useCallback((ids: string[]) => setExpanded(ids), []);
    const collapseAll = useCallback(() => setExpanded([]), []);

    return { expanded, setExpanded, toggle, expandAll, collapseAll };
};
